const topics = [
  {
    title: 'Why Pact exists',
    description:
      'Beauty packaging is complex—mixed materials, pumps, mirrors, magnets. Pact keeps it out of landfill by collecting, sorting, and channeling it into the best available recycling stream.',
  },
  {
    title: 'What we accept',
    description:
      'If it once held a beauty, skincare, or wellness product, Pact will take a look. Think mascaras, lipstick tubes, compacts, pumps, caps, droppers, and mini bottles. Just clean and dry first.',
  },
  {
    title: 'Where your empties go',
    description:
      'Partner facilities dismantle, sort, and send material to recycling or energy partners. Brands receive insight to design smarter packaging.',
  },
  {
    title: 'How to clean properly',
    description:
      'Rinse out any product residue, remove applicators when possible, and let everything air-dry before you drop it off or mail it back.',
  },
  {
    title: 'Mail-back checklist',
    description:
      'Bundle small items inside a larger container, include only accepted materials, and send within 14 days of printing your label.',
  },
  {
    title: 'Community stories',
    description:
      'Pact members—from indie brands to global retailers—are building circular beauty together. Your participation helps scale the system.',
  },
];

function Education() {
  return (
    <div className="space-y-14">
      <section className="card bg-base-100 shadow-xl">
        <div className="card-body grid gap-10 lg:grid-cols-[1fr_0.7fr]">
          <div className="space-y-5">
            <span className="badge badge-outline badge-primary badge-lg uppercase tracking-[0.18em]">
              Beauty in the loop
            </span>
            <h1 className="text-4xl font-semibold text-primary sm:text-5xl">Learn about Pact</h1>
            <p className="text-base text-neutral">
              Pact is the non-profit that keeps hard-to-recycle beauty packaging in rotation. Explore how the system
              works, what we accept, and why every empty counts toward a more circular industry.
            </p>
            <div className="flex flex-wrap gap-3 text-sm">
              <a href="https://www.pactcollective.org/program" className="btn btn-primary rounded-full" target="_blank" rel="noreferrer">
                How Pact works
              </a>
              <a href="https://www.pactcollective.org/resources" className="btn btn-outline rounded-full" target="_blank" rel="noreferrer">
                Packaging guidelines
              </a>
            </div>
          </div>
          <div className="space-y-3 rounded-3xl border border-base-200 bg-primary/5 p-6 text-sm text-neutral">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">What to remember</p>
            <ul className="space-y-2">
              <li>✔ Clean, empty, and dry items only</li>
              <li>✔ Remove leftover product and applicators when possible</li>
              <li>✔ Check your verification results for special instructions</li>
              <li>✔ Keep your email handy—we’ll send a recap after each verification</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {topics.map((topic) => (
          <article key={topic.title} className="card bg-base-100 shadow-lg">
            <div className="card-body space-y-2">
              <h2 className="card-title text-xl text-primary">{topic.title}</h2>
              <p className="text-sm text-neutral">{topic.description}</p>
            </div>
          </article>
        ))}
      </section>

      <section className="card bg-base-100 shadow-xl">
        <div className="card-body space-y-4">
          <h2 className="text-3xl font-semibold text-primary">Take the next step</h2>
          <p className="max-w-2xl text-sm text-neutral">
            Whether you drop off in store or mail back from home, Pact routes your packaging responsibly. Verified
            results, mail-back labels, and education resources all live within this experience.
          </p>
          <div className="flex flex-wrap gap-3 text-sm">
            <a href="https://www.pactcollective.org/impact" className="btn btn-outline rounded-full" target="_blank" rel="noreferrer">
              Explore impact stories
            </a>
            <a href="https://www.pactcollective.org/members" className="btn btn-outline rounded-full" target="_blank" rel="noreferrer">
              Meet Pact members
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Education;
